<template>
  <div class="history-list">
    <div class="history-info">
      <div class="history-icon"><img :src="logoIcon" alt="" /></div>
      <div class="history-text">
        <div class="history-name">{{ list.benefitName }}</div>
        <div class="history-desc">{{ list.benefitDesc }}</div>
      </div>
    </div>
    <div class="history-time">
      {{ $t("FoodC_C_Time_of_LACt") }}：{{ list.purchasingTime }}
    </div>
    <div class="history-price">
      {{ $t("FoodC_C_Purchase_amount_RXkR") }}：{{ list.priceSplit.display }}
    </div>
  </div>
</template>

<script>
import didiLogo from '@/assets/images/couponCenter/didifood.png'
import Logo99 from '@/assets/images/couponCenter/99logo.png'
export default {
  props: ['list'],
  computed: {
    country () {
      return this.$store.state.country
    },
    logoIcon () {
      if (this.country === 'BR') {
        return Logo99
      } else {
        return didiLogo
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.history-list {
  margin-bottom: 24px;
  height: 250px;
  background: #ffffff;
  border-radius: 8px;
  padding: 32px;
  box-sizing: border-box;
}
.history-info {
  display: flex;
  margin-bottom: 32px;
}
.history-icon {
  width: 102px;
  height: 102px;
  border-radius: 8px;
  overflow: hidden;
  margin-right: 20px;
  img {
    width: 102px;
    height: 102px;
  }
}
.history-text {
  padding-top: 13px;
  max-width: 490px;
}
.history-name {
  font-family: "Aspira Demi";
  font-size: 32px;
  color: #000000;
  line-height: 36px;
  font-weight: 500;
  margin-bottom: 10px;
  @extend .ellipsis;
}
.history-desc {
  font-family: "Aspira Demi";
  font-size: 24px;
  line-height: 26px;
  color: #000000;
  @extend .ellipsis;
}
.history-time {
  margin-bottom: 8px;
}
.history-time,
.history-price {
  max-width: 600px;
  font-family: "Aspira Demi";
  font-size: 22px;
  color: #999999;
  line-height: 24px;
  @extend .ellipsis;
}
</style>
